/* tslint:disable */
/* eslint-disable */
/**
 * Hyper GES API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TenantContattoCreateDTO
 */
export interface TenantContattoCreateDTO {
    /**
     * 
     * @type {string}
     * @memberof TenantContattoCreateDTO
     */
    cognome?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantContattoCreateDTO
     */
    nome?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantContattoCreateDTO
     */
    ruolo?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantContattoCreateDTO
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantContattoCreateDTO
     */
    telefono?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantContattoCreateDTO
     */
    cellulare?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantContattoCreateDTO
     */
    note?: string;
}

/**
 * Check if a given object implements the TenantContattoCreateDTO interface.
 */
export function instanceOfTenantContattoCreateDTO(value: object): value is TenantContattoCreateDTO {
    return true;
}

export function TenantContattoCreateDTOFromJSON(json: any): TenantContattoCreateDTO {
    return TenantContattoCreateDTOFromJSONTyped(json, false);
}

export function TenantContattoCreateDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): TenantContattoCreateDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'cognome': json['cognome'] == null ? undefined : json['cognome'],
        'nome': json['nome'] == null ? undefined : json['nome'],
        'ruolo': json['ruolo'] == null ? undefined : json['ruolo'],
        'email': json['email'] == null ? undefined : json['email'],
        'telefono': json['telefono'] == null ? undefined : json['telefono'],
        'cellulare': json['cellulare'] == null ? undefined : json['cellulare'],
        'note': json['note'] == null ? undefined : json['note'],
    };
}

export function TenantContattoCreateDTOToJSON(value?: TenantContattoCreateDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'cognome': value['cognome'],
        'nome': value['nome'],
        'ruolo': value['ruolo'],
        'email': value['email'],
        'telefono': value['telefono'],
        'cellulare': value['cellulare'],
        'note': value['note'],
    };
}

